import React,{useState}  from 'react'
import {Box,Typography,Container,Button, TextField, InputAdornment, InputLabel, Input, FormControlLabel, RadioGroup, Radio, Divider} from '@mui/material'
import {useTheme,styled } from '@mui/material/styles'
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowIcon from '@mui/icons-material/ArrowBackRounded';
import CircularProgress from '@mui/material/CircularProgress';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import {IconButton} from "@mui/material"
import {useNavigate} from 'react-router-dom'
import Header from '../Components/Header'
import FormControl from '@mui/material/FormControl';
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import axios from 'axios'
import Snackbar from '@mui/material/Snackbar'
import { useParams } from 'react-router-dom';
import { Alarm, ArrowCircleUpOutlined, ArrowDropDown, ArrowDropDownCircleOutlined, ArrowDropUp, CalendarTodayOutlined, Group, LocalCafe, LocationDisabledRounded, MicRounded, More, PeopleOutlineOutlined, Person2Outlined, Person3Rounded, QuizOutlined, Search, SearchOutlined, Visibility } from '@mui/icons-material';
import { add_job } from '../Redux/jobSlice';
import { CalendarIcon } from '@mui/x-date-pickers';
// import {
// 	EmailShareButton,
// 	FacebookShareButton,
// 	InstapaperShareButton,
// 	LinkedinShareButton,
// 	MailruShareButton,
// 	RedditShareButton,
// 	TelegramShareButton,
// 	TumblrShareButton,
// 	TwitterShareButton,
// 	ViberShareButton,
// 	VKShareButton,
// 	WhatsappShareButton,
// 	WorkplaceShareButton,
// 	FacebookShareCount
//   } from "react-share";


const SearchBox = styled(Box)(({ theme }) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
    }),
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
        width: 10,
        backgroundColor: '#060202'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#ffffff',
        borderRadius: 10
    },
	background:theme.palette.mode === 'dark'? '#100101' : 'white',
	flexDirection:"row",
	display:"flex",
	justifyContent:"space-between",
	alignItems:"center",
	borderRadius:10,
	margin:10,
	width:"50%"
}));

const BodyBox = styled(Box)(({ theme }) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
    }),
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
        width: 5,
        backgroundColor: '#060202'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#ffffff',
        borderRadius: 5
    },
	background:theme.palette.mode === 'dark'? '#100101' : 'white',
	flexDirection:"row",
	display:"flex",
	justifyContent:"space-between",
	alignItems:"flex-start",
	borderRadius:5,
	minHeight:450,
	maxHeight:450,
	margin:5
}));

const MainBox = styled(Box)(({ theme }) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
    }),
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
        width: 5,
        backgroundColor: '#060202'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#ffffff',
        borderRadius: 5
    },
	background:theme.palette.mode === 'dark'? '#100101' : 'white',
	justifyContent:"flex-start",
	alignItems:"flex-start",
	borderRadius:10,
	margin:10,
	width:"55%",
	minHeight:420,
	maxHeight:420
}));

const MoreBox = styled(Box)(({ theme }) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
    }),
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
        width: 5,
        backgroundColor: '#060202'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#ffffff',
        borderRadius: 5
    },
	background:theme.palette.mode === 'dark'? '#100101' : 'white',
	justifyContent:"flex-start",
	alignItems:"flex-start",
	borderRadius:10,
	margin:10,
	width:"45%",
	minHeight:400,
	maxHeight:400
}));

const HeaderBox = styled(Box)(({ theme }) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
    }),
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
        width: 7,
        backgroundColor: '#060202'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#ffffff',
        borderRadius: 5
    },
	background:theme.palette.mode === 'dark'? 'black' : 'white',
}));


const Job = ()=>{

	const theme = useTheme()
	const test = useSelector(state => state?.test.test);
	const navigate = useNavigate()
	const [lang, setLang] = useState(test?.language);
	const [loading, setLoading] = useState(false);
	const [applying, setApplying] = useState(false);
	const [open, setOpen] = React.useState(false);
	const [showDialog, setShowDialog] = React.useState(false);
	const [isNext, setIsNext] = React.useState(false);
    const [expand, setExpand] = React.useState(true);
	const [message, setMessage] = React.useState("");
	const [participants, setParticipants] = React.useState([]);
	const user = useSelector(state => state?.auth.user);
    const { id } = useParams()
    const [search, setSearch] = React.useState("");
    const [filter, setFilter] = React.useState("");
	const [field, setField] = React.useState("");
	const [location, setLocation] = React.useState(null);
	const [type, setType] = React.useState(null);
	const [category, setCategory] = React.useState(null);
    const [searching, setSearching] = React.useState(false);
	const [data, setData] = React.useState({});
	const [otherJobs, setOtherJobs] = React.useState([]);
	const [select, setSelect] = React.useState(0);
	const recorder = React.useRef(null)
	const [showConfirm, setShowConfirm] = React.useState(false);
	const [fetching, setFetching] = React.useState(false);
	const [filtering, setFiltering] = React.useState(false);
	const [viewing, setViewing] = React.useState(false);
	const [hasData, setHasData] = React.useState(false);
	const [content, setContent] = React.useState("");
	const [showContent, setShowContent] = React.useState(false);
	const [selected, setSelected] = React.useState(0);
	const dispatch = useDispatch()

const handleApplyItem = async (id)=>{
	try {
		if (user?.auth) {
			setViewing(true)

			const data = {
				email:user?.email,
				id:id
			}
	
			const getJob = await axios.post(`${process.env.REACT_APP_SOCKET_URL}api/user/apply-offer/`,data,{
				headers:{
					"Content-Type":"application/json",
					"Authorization":`Bear ${user?.accessToken}`
				}
			}).catch(err=>{
				console.log(err)
				setViewing(false)
				setMessage("please,check your connection and try again")
				setOpen(true)
			})
	
			if (getJob?.status == 200 && getJob?.data?.success) {
				dispatch(add_job(getJob?.data?.job))
				navigate("/jobApplication")
			}else{
				setMessage(getJob?.data?.message)
				setOpen(true)
			}
			setViewing(false)
		} else {
			setMessage("You have to create an account before applying to an offer...redirecting....")
			setOpen(true)
			setTimeout(()=>{
				navigate("/signup")
			},3000)
		}
	} catch (error) {
		console.log(error)
	}
}

const handleApply = async (id)=>{
	try {
		if (user?.auth) {
			setApplying(true)

			const data = {
				email:user?.email,
				id:id
			}
	
			const getJob = await axios.post(`${process.env.REACT_APP_SOCKET_URL}api/user/apply-offer/`,data,{
				headers:{
					"Content-Type":"application/json",
					"Authorization":`Bear ${user?.accessToken}`
				}
			}).catch(err=>{
				console.log(err)
				setApplying(false)
				setMessage("please,check your connection and try again")
				setOpen(true)
			})
	
			if (getJob?.status == 200 && getJob?.data?.success) {
				dispatch(add_job(getJob?.data?.job))
				navigate("/jobApplication")
			}else{
				setMessage(getJob?.data?.message)
				setOpen(true)
			}
			setApplying(false)
		} else {
			setMessage("You have to create an account before applying to an offer...redirecting....")
			setOpen(true)
			setTimeout(()=>{
				navigate("/signup")
			},3000)
		}
	} catch (error) {
		console.log(error)
	}
}

const handleGetJob = async ()=>{
    try {
		setFetching(true)
		setHasData(false)

        const getJob = await axios.get(`${process.env.REACT_APP_SOCKET_URL}api/usr/get-job/${id}`).catch(err=>{
			console.log(err)
			setFetching(false)
			setMessage("please,check your connection and try again")
			setOpen(true)
		})

		if (getJob?.status == 200 && getJob?.data?.success) {
			dispatch(add_job(getJob?.data?.job))
			setData(getJob?.data?.job)
			setHasData(true)
		}else{
			setMessage(getJob?.data?.message)
			setOpen(true)
		}
		setFetching(false)
    } catch (error) {
        console.log(error)
    }
}

const handleGetJobs = async ()=>{
    try {

		setLoading(true)

        const getJobs = await axios.get(`${process.env.REACT_APP_SOCKET_URL}api/usr/get-all-jobs/${id}`).catch(err=>{
			setLoading(false)
			setMessage("please,check your connection and try again")
			setOpen(true)
		})

		if (getJobs?.status == 200 && getJobs?.data?.success) {
			// setPublicData(getJobs?.data.publicTemplates)
			setOtherJobs(getJobs?.data.jobs)
			console.log(getJobs?.data)
		}
		setLoading(false)
    } catch (error) {
        console.log(error)
    }
}


const handleSnackbarClose = ()=>{
	setOpen(false)
}
React.useLayoutEffect(()=>{
	handleGetJob(id)
	handleGetJobs()
},[id])


	return(
		<Box width="100%" mt={1}>	
			<Container>
				<Snackbar 
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}} 
					message={message} 
					onClose={handleSnackbarClose} 
					open={open} 
					autoHideDuration={2000}
				/>
				<HeaderBox>
					<Box sx={{flexDirection:"row",display:"flex",justifyContent:"space-between",alignItems:"center",width:"90%",ml:3,mt:1}}>
						<Box sx={{flexDirection:"row",display:"flex",justifyContent:"space-between",alignItems:"center",width:"50%"}}>
							<IconButton onClick={(e)=>{
								e?.preventDefault()
								navigate("/dashboard")
							}} sx={{display:{xs:"none",md:"flex"}}}>
								<img width={25} height={25} style={{marginRight:4}} src={require('../assets/test.png')}/>
								<Typography
									variant="h6"
									noWrap
									component="div"
									sx={{ display: { xs: 'none', sm: 'block' ,fontSize:25,marginLeft:1,fontFamily:"zolla"} }}
								>
									iTest
								</Typography>
							</IconButton>
							<Box sx={{flexDirection:"row",display:"flex",justifyContent:"space-evenly",alignItems:"center",width:"50%"}}>
								<IconButton onClick={(e)=>{
									e?.preventDefault()
									if(user?.auth){
										navigate("/jobs")
									}else{
										navigate("/signup")
									}
								}} sx={{borderRadius:1,background:"#ff0",color:"#000"}}>
									<Typography sx={{fontSize:13}}>
										Find Offer
									</Typography>
								</IconButton>
							{
								user?.auth 
								?
								<>
								<IconButton onClick={(e)=>{
									e?.preventDefault()
									navigate("/addJob")
								}} sx={{borderRadius:1}}>
									<Typography sx={{fontSize:13}}>
										Post Offer
									</Typography>
								</IconButton>
								<IconButton onClick={(e)=>{
									e?.preventDefault()
									navigate("/myJobs")
								}} sx={{borderRadius:1}}>
									<Typography sx={{fontSize:13}}>
										My Offers
									</Typography>
								</IconButton>
								</>
								:
								<>
								<IconButton onClick={(e)=>{
									e?.preventDefault()
									navigate("/login")
								}} sx={{borderRadius:1}}>
									<Typography sx={{fontSize:13}}>
										Login
									</Typography>
								</IconButton>
								<IconButton onClick={(e)=>{
									e?.preventDefault()
									navigate("/signup")
								}} sx={{borderRadius:1}}>
									<Typography sx={{fontSize:13}}>
										Sign up
									</Typography>
								</IconButton>
								</>
							}
							</Box>
						</Box>
						{
							user?.auth && (
							<IconButton onClick={(e)=>{
								e?.preventDefault()
								navigate("/profile")
							}} sx={{borderRadius:1,background:"#fff",display:{xs:"none",md:"flex"}}}>
								<img width={25} height={25} style={{borderRadius:20}} src={user?.profile !== "https://" ? user?.profile : require("../assets/avatar.jpg")}/>
								<Typography sx={{fontSize:13,marginLeft:1,color:"#000" }}>
									{user?.first_name}
								</Typography>
							</IconButton>								
							)
						}
					</Box>
				</HeaderBox>
				<Typography sx={{fontSize:18,ml:3,mt:3,fontFamily:"dinofans"}}>
					Offer description
				</Typography>
				<BodyBox >
					<MainBox sx={{width:{xs:"100%",md:"55%"}}}>
						   {
							fetching && (
								<Box textAlign="center" alignContent="center" alignItems="center" justifyContent="center" mt={10}>
									<CircularProgress size={20} sx={{color:"#fff"}}/>
								</Box>
							)
						   }
						   {
							(!fetching && !hasData) && (
								<Box textAlign="center" alignContent="center" alignItems="center" justifyContent="center">
									<Box justifyContent="center" alignItems="center" mt={10}>
										<img  width={50} height={80} src="https://res.cloudinary.com/irihocloud/image/upload/v1731198104/r14klvgmrdt5syskccyi.gif" alt="keep up" />
									</Box>
									<Typography sx={{fontSize:11,mt:3}}>
										we could not fetch the offer, refresh the page
									</Typography>
								</Box>
								
							)
						   }
						   {
							(!fetching && hasData) && (
								<Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-between" alignItems="center" width="100%" >
									<Box display="flex" flexDirection="row" width="80%" flexWrap="wrap" justifyContent="space-evenly" mt={1}>
									<img resizemode="cover" src={data?.enterprise_logo} width={75} height={75} style={{marginRight:5}}/>
										<Box justifyContent="center" alignItems="center" width={200}>
											<Typography sx={{fontFamily:"dinofans",fontSize:14}}>
												{data?.title}
											</Typography>
											<Typography sx={{fontSize:13}}>
												{data?.enterprise_name?.toLocaleUpperCase()}
											</Typography>
											<Typography sx={{fontSize:13,color:"#ff0"}}>
												{data?.type}
											</Typography>
										</Box>
										<IconButton onClick={async (e)=>{
											e?.preventDefault()
											await handleApply(data?.id)
										}} disabled={applying} sx={{mt:{xs:1},backgroundColor:"#ff0",borderRadius:1,width:100,height:30,textAlign:"center"}}>
											{
											(applying) ? 
												<CircularProgress sx={{color:"#fff"}} size={15}/>
											: 
												<Typography sx={{fontSize:12,color:"#000",fontWeight:"bold"}}>
													Apply
												</Typography>
											}
										</IconButton>
									</Box>
									<Box display="flex" flexDirection="row" width="70%" flexWrap="wrap" justifyContent="space-between" alignItems="flex-start" mt={1} sx={{ml:{md:3}}}>
										<Box>
											<Typography sx={{fontFamily:"dinofans",fontSize:14}}>
												Category
											</Typography>
											<Typography sx={{fontSize:13}}>
												{data?.category}
											</Typography>
										</Box>
										<Box>
											<Typography sx={{fontFamily:"dinofans",fontSize:14}}>
												Location
											</Typography>
											<Typography sx={{fontSize:13}}>
												{data?.location}
											</Typography>
										</Box>
										<Box>
											<Typography sx={{fontFamily:"dinofans",fontSize:14,color:"red"}}>
												Deadline
											</Typography>
											<Typography sx={{fontSize:13,color:"red"}}>
												{data?.deadline}
											</Typography>
										</Box>
									</Box>
									<Box width="70%" sx={{ml:{md:3},mt:1}}>
										<Typography sx={{fontFamily:"dinofans",fontSize:14,color:"#ff0"}}>
											Benefits
										</Typography>
										<ol>
											{
												data?.benefits?.map((itm,index)=>(
													<li style={{color:"#fff",fontSize:12}} key={index}>
														{itm}
													</li>
												))
											}
										</ol>
									</Box>
									<Box width="70%" sx={{ml:{md:3},mt:1}}>
										<Typography sx={{fontFamily:"dinofans",fontSize:14,color:"#ff0"}}>
											Eligibilities
										</Typography>
										<ol>
											{
												data?.eligibilities?.map((itm,index)=>(
													<li style={{color:"#fff",fontSize:12}} key={index}>
														{itm}
													</li>
												))
											}
										</ol>
									</Box>
									<Box sx={{p:2,width:"100%",flexWrap:"wrap",flexDirection:"row",display:"flex",justifyContent:"flex-start",textAlign:"left"}}>

									</Box>
									<Box width="70%" sx={{ml:{md:3},mt:1}}>
										<Typography sx={{fontFamily:"dinofans",fontSize:14,color:"#ff0"}}>
											Offer Description
										</Typography>
										<Typography sx={{fontSize:13}}>
											{data?.description}
										</Typography>
									</Box>
									<Box width="70%" sx={{ml:{md:3},mt:1}}>
										<Typography sx={{fontFamily:"dinofans",fontSize:14,color:"#ff0"}}>
											Organization Description
										</Typography>
										<Typography sx={{fontSize:13}}>
											{data?.enterprise_description}
										</Typography>
									</Box>
							</Box>
							)
						   }
					</MainBox>
					<MoreBox sx={{display:{xs:"none",md:"block"}}}>
					{
						(loading ) && (
							<Box textAlign="center" alignContent="center" justifyContent="center" mt={10}>
								<CircularProgress size={20} sx={{color:"#fff"}}/>
							</Box>
							
						)
					}
					{
						(!loading && otherJobs.length == 0) && (
							<Box textAlign="center" alignContent="center" alignItems="center" justifyContent="center">
									<Box justifyContent="center" alignItems="center" mt={10}>
										<img  width={50} height={80} src="https://res.cloudinary.com/irihocloud/image/upload/v1731198104/r14klvgmrdt5syskccyi.gif" alt="keep up" />
									</Box>
									<Typography sx={{fontSize:11,mt:3}}>
										we could not fetch any other offers or there isn't any
									</Typography>
								</Box>
							
						)
					}
					{
						(!loading && otherJobs.length > 0) &&(
							<Box p={1} textAlign="left" justifyContent="flex-start" width="100%">
								<Typography sx={{fontFamily:"dinofans",fontSize:12,color:"#ff0"}}>
									Other available offers
								</Typography>
								<Box m={1}>
									{
										otherJobs?.map((item,index)=>(
											<>
											<Box key={index} width="100%" alignItems="center" justifyContent="space-between" flexDirection="row" display="flex"  flexWrap="wrap">
												<img  width={70} height={70} resizemode="cover" style={{borderRadius:5}} src={item?.enterprise_logo} />
												<Box m={1} width={150}>
													<Typography sx={{fontFamily:"dinofans",fontSize:14}}>
														{item?.title}
													</Typography>
													<Typography sx={{fontSize:13}}>
														{item?.enterprise_name?.toLocaleUpperCase()}
													</Typography>
													<Typography sx={{fontSize:13,color:"#ff0"}}>
														{item?.type}
													</Typography>
												</Box>
												<Box m={1}>
													<IconButton sx={{borderRadius:1,backgroundColor:"#000"}}>
														<Alarm fontSize='small' sx={{color:"red"}}/>
														<Typography sx={{fontSize:13,color:"red",pl:1}}>
															{item?.deadline}
														</Typography>
													</IconButton>
													<Typography sx={{fontSize:13,pl:1}}>
														{item?.location ? item?.location : "unknown"}
													</Typography>
													<Typography sx={{fontSize:13,pl:1}}>
														{item?.category}
													</Typography>
												</Box>
												<Box display="flex" flexDirection="column">
													<IconButton onClick={async (e)=>{
														e?.preventDefault()
														setSelected(index)
														await handleApplyItem(item?.id)
													}} disabled={viewing} sx={{mt:{xs:1},backgroundColor:"#ff0",borderRadius:1,width:100,height:30,textAlign:"center"}}>
														{
														(viewing && selected == index) ? 
															<CircularProgress sx={{color:"#fff"}} size={15}/>
														: 
															<Typography sx={{fontSize:12,color:"#000",fontWeight:"bold"}}>
																Apply
															</Typography>
														}
													</IconButton>
													<IconButton onClick={(e)=>{
														window.location.href = `https://itest-mocha.vercel.app/job/${item?.id}`
													}} sx={{mt:{xs:1},backgroundColor:"#fff",borderRadius:1,width:100,height:30,textAlign:"center"}}>
														<Typography sx={{fontSize:12,color:"#000",fontWeight:"bold"}}>
															View
														</Typography>
													</IconButton>
												</Box>
											</Box>
											<Divider sx={{mt:1,mb:1}}/>
											</>
										))
									}
								</Box>
							</Box>
						)
					}
					</MoreBox>
				</BodyBox>
			</Container>
		</Box>
		)
}

export default Job